export const normalizeUrl = (url: string): string => {
	const trimmedUrl = url?.trim().toLocaleLowerCase();

	if (!trimmedUrl) {
		return trimmedUrl;
	}

	// Check if it already has protocol (http:// or https://)
	const hasProtocol = /^https?:\/\//i.test(trimmedUrl);

	// If it doesn't have protocol, add https://
	return hasProtocol ? trimmedUrl : `https://${trimmedUrl}`;
};
